import { Box, Flex, Spinner, Text } from '@chakra-ui/react'
import React, { FC } from 'react'
import { useCart } from 'src/services/api/queries/queries'
import { CartFormProps } from '../../types'

import { useTranslation } from 'react-i18next'
import { ReactComponent as EmptyCart } from 'src/assets/images/empty-cart.svg'
import { formatPrice } from 'src/utils/cart'
import NextButton from '../NextButton'
import CartList from './CartList'
import DiscountCodeInput from './DiscoundCodeInput'
import TotalAmount from './TotalAmount'

const CartProducts: FC<CartFormProps> = ({ onNext }) => {
  const { t } = useTranslation()
  const { data, isLoading, isError } = useCart()

  const shippingFee = formatPrice(
    data?.totals.total_shipping,
    data?.totals.currency_symbol,
    data?.totals.currency_minor_unit
  )
  const total = formatPrice(
    data?.totals.total_price,
    data?.totals.currency_symbol,
    data?.totals.currency_minor_unit
  )

  if (isLoading) {
    return <Spinner />
  }

  if (isError) {
    return <Box>{t('cartPages.errorCart')}</Box>
  }

  if (data?.items.length === 0) {
    return (
      <Flex direction='column' justifyContent='center' alignItems='center' height='60vh'>
        <EmptyCart />
        <Text fontSize='lg' fontWeight='bold' mt={4}>
          {t('cartPages.emptyCart')}
        </Text>
      </Flex>
    )
  }

  return (
    <Flex direction='column' justifyContent='space-between' width='100%' height='85vh' px='2rem'>
      <Box height='50vh'>
        <CartList items={data?.items ?? []} />
        <DiscountCodeInput />
      </Box>
      <Box>
        <TotalAmount shippingFee={shippingFee} total={total} />
        <NextButton onClick={() => onNext()} />
      </Box>
    </Flex>
  )
}

export default CartProducts
